import React, { useEffect } from 'react';

import {
  Navbar, Footer, BlogMail, BlogHeader, BlogCard
} from '../../components';
import authorImage from '../../assets/images/author.svg';
import articleImage from '../../assets/images/thumbnail.svg';

const Blog = ({ contact }) => {
  const article1 = {
    articleImage,
    authorImage,
    authorName: 'Jenny Wilson',
    authorRole: 'Product Manager',
    body: 'At Monzo we process a lot of payments and really important to us and our customers that we process them correctly. That means that we have to take a lot of care not to introduce any bugs when we deploy changes, especially when changing the hot path of our payment systems. However, at the same time we are a high-growth tech company, so shipping frequently is key to our success.In theory, these two competing priorities should put us in a difficult spot, but in practice we manage to ship many times a day while making sure that payments are processed as expected. This blog post explores how we do this and focuses on two ideas that could be useful outside of the world of payment processing.At Monzo we process a lot of payments and really important to us and our customers that we process them correctly. That means that we have to take a lot of care not to introduce any bugs when we deploy changes, especially when changing the hot path of our payment systems. However, at the same time we are a high-growth tech company, so shipping frequently is key to our success.In theory, these two competing priorities should put us in a difficult spot, but in practice we manage to ship many times a day while making sure that payments are processed as expected. This blog post explores how we do this and focuses on two ideas that could be useful outside of the world of payment processing.At Monzo we process a lot of payments and really important to us and our customers that we process them correctly. That means that we have to take a lot of care not to introduce any bugs when we deploy changes, especially when changing the hot path of our payment systems. However, at the same time we are a high-growth tech company, so shipping frequently is key to our success.In theory, these two competing priorities should put us in a difficult spot, but in practice we manage to ship many times a day while making sure that payments are processed as expected. This blog post explores how we do this and focuses on two ideas that could be useful outside of the world of payment processing.At Monzo we process a lot of payments and really important to us and our customers that we process them correctly. That means that we have to take a lot of care not to introduce any bugs when we deploy changes, especially when changing the hot path of our payment systems. However, at the same time we are a high-growth tech company, so shipping frequently is key to our success.In theory, these two competing priorities should put us in a difficult spot, but in practice we manage to ship many times a day while making sure that payments are processed as expected. This blog post explores how we do this and focuses on two ideas that could be useful outside of the world of payment processing.',
    date: '6 June 2022',
    tag: 'Product Updates',
    topic: 'My First 3 Months as a Software Engineer at Carrot',
  };

  useEffect(() => {
    if (window.groove.widget) window.groove.widget.destroy();

    return () => {
      if (window.groove.widget) window.groove.widget.init('697d31d3-878e-400c-bd9d-96926e6917f8', {});
    };
  });

  return (
    <div>
      <div className="navbar-wrap">
        <Navbar />
      </div>
      <BlogHeader
        topic={article1.topic}
        authorImage={article1.authorImage}
        authorName={article1.authorName}
        authorRole={article1.authorRole}
      />

      <section id="blog-list">
        <BlogCard
          blogCardImage={article1.articleImage}
          blogCardBody={article1.body}
          blogCardDate={article1.date}
          blogCardTitle={article1.topic}
          blogCardTag={article1.tag}
        />

        <BlogCard
          blogCardImage={article1.articleImage}
          blogCardBody={article1.body}
          blogCardDate={article1.date}
          blogCardTitle={article1.topic}
          blogCardTag={article1.tag}
        />
      </section>

      <section id="blog-page">
        <BlogCard
          blogCardImage={article1.articleImage}
          blogCardBody={article1.body}
          blogCardDate={article1.date}
          blogCardTitle={article1.topic}
          blogCardTag={article1.tag}
          active
        />
      </section>

      <BlogMail contact={contact} />

      <Footer />
    </div>
  );
};

export default Blog;
